import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Section = ({ title, children }) => (
  <section style={{ background: '#fff', padding: '1.25rem', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
    <h2 style={{ marginTop: 0, color: '#2c6e49' }}>{title}</h2>
    <div style={{ color: '#333', lineHeight: 1.65 }}>{children}</div>
  </section>
);

const SpacedRepetitionGuide = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('guideSpacedRepetition') || 'Spaced Repetition (SM-2) Guide'}</h1>
        <p>{t('learnLanguagesSmartWay')}</p>
      </header>

      <main className="landing-main" style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gap: '1rem' }}>
        <Section title={t('whatIsSm2') || 'What is SM-2?'}>
          <p>
            {t('sm2Intro') || 'SM-2 is a proven spaced-repetition algorithm that schedules reviews right before you are likely to forget. Each time you review a card, its interval adjusts based on your performance.'}
          </p>
          <ul>
            <li>{t('sm2PointAdaptive') || 'Adaptive intervals based on success or mistakes'}</li>
            <li>{t('sm2PointDue') || 'Prioritizes due items to maximize retention'}</li>
            <li>{t('sm2PointEfficient') || 'Minimizes total study time for the same results'}</li>
          </ul>
        </Section>

        <Section title={t('howSafaCardsUsesSm2') || 'How SafaCards uses SM-2'}>
          <p>
            {t('sm2HowSafaCards') || 'In SafaCards, the Review All Words page uses SM-2 across your words. Learning Mode is for rapid exposure while you get familiar. Then switch to Review All Words to lock them into long‑term memory.'}
          </p>
        </Section>

        <Section title={t('bestPractices') || 'Best practices with SafaCards'}>
          <ul>
            <li>{t('sm2TipGroups') || 'Create groups of about 25 words for focused sessions.'}</li>
            <li>{t('sm2TipLearningMode') || 'Start in Learning Mode to warm up and see each item a few times.'}</li>
            <li>{t('sm2TipReviewAll') || 'Move to Review All Words (SM-2) to consolidate memory.'}</li>
            <li>{t('sm2TipDaily') || 'Study daily; short, consistent sessions outperform long cramming.'}</li>
            <li>{t('sm2TipContext') || 'Use context features (sentences, stories) to reinforce meaning.'}</li>
          </ul>
        </Section>

        <Section title={t('faq') || 'FAQ'}>
          <p><strong>{t('sm2FaqEditTitle') || 'Q: Do I lose progress if I edit words?'}</strong><br />{t('sm2FaqEditAns') || 'A: Edits don’t reset your SRS history; the schedule continues.'}</p>
          <p><strong>{t('sm2FaqHonestTitle') || 'Q: Should I mark guesses as correct?'}</strong><br />{t('sm2FaqHonestAns') || 'A: Be honest. Over‑marking “knew it” delays the next review too much.'}</p>
          <p><strong>{t('sm2FaqBatchTitle') || 'Q: How often should I add new words?'}</strong><br />{t('sm2FaqBatchAns') || 'A: Add modest batches regularly so SM‑2 can pace your workload.'}</p>
        </Section>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default SpacedRepetitionGuide;


